module.exports = __webpack_public_path__ + "img/Popup Alert-Information0.cd007853.png";